import * as React from 'react'

export default class Eva extends React.Component {
  static optionValue = 'Eva'

  render () {
    const pieceId = 'Eyes/Eva'

    return (
      <g id={pieceId}
         stroke='none'
         strokeWidth='1'
         fill='none'
         fillRule='evenodd'>
        <path
          d='M53,0 C87.746885,0 102.000559,17.474163 102,31 C101.999441,44.525837 82.4108252,48 53,48 C23.9528111,48 2,44.525837 2,31 C2,17.474163 17.1141791,3.17100737e-15 53,0 Z'
          id='Path-2'
          fillOpacity='0.8'
          fill='#000000'/>
        <g id='EeeeVaaaa'
           transform='translate(18.000000, 16.000000)'
           fill='#25A6F5'>
          <path
            d='M10.817693,18.6539934 C4.29096139,17.3000653 -0.41691297,12.312077 0.302361333,7.51300959 C1.02163564,2.7139422 6.89568406,-0.0788950027 13.4224157,1.2750331 C19.9491473,2.6289612 24.6570217,7.61694957 23.9377474,12.416017 C23.2184731,17.2150843 17.3444247,20.0079215 10.817693,18.6539934 Z'
            id='vaaaa'/>
          <path
            d='M57.4224157,18.6539934 C50.8956841,20.0079215 45.0216356,17.2150843 44.3023613,12.416017 C43.583087,7.61694957 48.2909614,2.6289612 54.817693,1.2750331 C61.3444247,-0.0788950027 67.2184731,2.7139422 67.9377474,7.51300959 C68.6570217,12.312077 63.9491473,17.3000653 57.4224157,18.6539934 Z'
            id='eeee'/>
        </g>
      </g>
    )
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/bottts/bot/eyes/Eva.tsx